var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.src)?_c('img',{attrs:{"alt":_vm.ariaLabel,"aria-label":_vm.ariaLabel,"src":_vm.src}}):_c('blank-img')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }